import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-view" }

import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const user = computed(() => store.getters['cabinet/user']);

onMounted(() => {
  const company = user.value.companies[0] || {};
  if (!company.id) {
    return;
  }

  switch (company.role) {
    case 'accountant': {
      router.replace({
        name: 'accountant/settlements',
        params: {
          id: company.id,
          type: 'company',
        },
      });

      return;
    }
  }

  const getCompanyRouteTypeById = computed(() => store.getters['cabinet/companyRouteTypeById']);
  const companyType = getCompanyRouteTypeById.value(company.id);

  router.replace({
    name: 'orders',
    params: {
      id: companyType === 'station' ? company.contract.id : company.id,
      type: getCompanyRouteTypeById.value(company.id),
    },
    query: route.query,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})